import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const SeoSocial = ({
  url,
  description,
  title,
  imageUrl
}) => {
  const { site } = useStaticQuery(
    graphql`
        query SiteSocialQuery {
            site {
                siteMetadata {
                    siteName
                    description
                    author
                }
            }
        }
    `,
  );

  const metaUrl = url || 'https://apps.bostonglobe.com/opinion/graphics/2021/12/words-of-the-year';

  const metaDescription = description || 'Every year, new words enter the public lexicon, and 2021 was no exception.';

  const metaTitle = title || 'Words of the Year';

  const metaImage = imageUrl || 'https://apps.bostonglobe.com/opinion/graphics/2021/12/words-of-the-year/images/share.png';

  return (
    <Helmet
      htmlAttributes={{
        lang: 'en-US',
      }}
      title={title}
      titleTemplate={`%s - ${site.siteMetadata.siteName}`}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: metaTitle,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        // {
        //   property: 'og:url',
        //   content: metaUrl,
        // },
        {
          // This is overridden in article.jsx.
          property: 'og:image',
          content: metaImage,
        },
        {
          property: 'og:site_name',
          content: 'BostonGlobe.com',
        },
        {
          property: 'og:type',
          content: 'article',
        },
        {
          property: 'og:city',
          content: 'Boston',
        },
        {
          property: 'og:state',
          content: 'MA',
        },
        {
          property: 'og:country',
          content: 'US',
        },
        {
          property: 'fb:admins',
          content: '100001044693856,507486035',
        },
        {
          property: 'fb:app_id',
          content: '103933749691726',
        },
        {
          property: 'fb:pages',
          content: '5637143257',
        },
        {
          property: 'article:publisher',
          content: 'https://www.facebook.com/globe',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:site',
          content: '@BostonGlobe',
        },
        {
          name: 'twitter:creator',
          content: '@BostonGlobe',
        },
        {
          name: 'twitter:title',
          content: metaTitle,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          // This is overridden in article.jsx.
          name: 'twitter:image',
          content: metaImage,
        },
        {
          name: 'twitter:url',
          content: metaUrl,
        },
      ]}
    />
  );
};

SeoSocial.defaultProps = {
  url: '',
  description: '',
  title: '',
  imageUrl: ''
};

SeoSocial.propTypes = {
  url: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  imageUrl: PropTypes.string
};

export default SeoSocial;
